module.exports = __webpack_public_path__ + "static/img/4.c2ec894.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/sp/4.png
// module id = 50Yf
// module chunks = 0